import { Tag, TagLabel, Tooltip } from '@chakra-ui/react'

interface Props {
	risk: string,
	color: string
}

const RiskBox = ({ risk, color }: Props) => {
	return (
		<Tooltip label={risk} placement="top">
			<Tag
				size="lg"
				borderRadius='full'
				variant='solid'
				colorScheme={color}
			>
				<TagLabel fontSize="sm">{risk}</TagLabel>
			</Tag>
		</Tooltip>
	)
}

export default RiskBox
